import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type OnboardingBankAccountAlertClickedProps = EventProps

/**
 * @event onboarding_bank_account_alert_clicked
 * @description Emitted when a user clicks the dashboard alert prompting them to add a nominated bank account.
 */
export const OnboardingBankAccountAlertClickedAnalytics = createAnalyticsStatic<OnboardingBankAccountAlertClickedProps>(
    ANALYTICS_EVENTS.ONBOARDING.ONBOARDING_BANK_ACCOUNT_ALERT_CLICKED,
)

export default OnboardingBankAccountAlertClickedAnalytics
